module.exports = __webpack_public_path__ + "img/mypage-active.79cae3c3.png";